import React, { useState } from "react";
import { ChevronLeft, ChatLeftDotsFill} from "react-bootstrap-icons";
import Style from "./Accardion6.module.scss";
import AccardionItem from "../AccardionItem/AccardionItem";

const Accardion6 = () => {

    const [openOnClick , setOpenOnClick]=useState(false)
    const [openOnClickList , setOpenOnClickList]=useState(false)
    const [openAll , setOpenAll]=useState(false)

    const createDiscount = [
        {
            id: "1",
            title: "تخفیف یک محصول ",
            link: "/productdiscount",
            active: window.location.pathname === "/productdiscount",
        },
        {
            id: "2",
            title: "تخفیف کل محصولات",
            link: "/allproductdiscount",
            active: window.location.pathname === "/allproductdiscount",
        },
        {
            id: "3",
            title: "تخفیف یک دسته بندی",
            link: "/categorydiscount",
            active: window.location.pathname === "/categorydiscount",
        }
    ];

    const Discounts = [
        {
            id: "1",
            title: "تخفیف یک محصول ",
            link: "/productdiscounted",
            active: window.location.pathname === "/productdiscounted",
        },
        {
            id: "2",
            title: "تخفیف کل محصولات",
            link: "/allproductdiscounted",
            active: window.location.pathname === "/allproductdiscounted",
        },
        {
            id: "3",
            title: "تخفیف یک دسته بندی",
            link: "/categorydiscounted",
            active: window.location.pathname === "/categorydiscounted",
        }
    ];
    
    const addDiscountCode = [
        {
            id: "1",
            title: "اختصاص کد تخفیف",
            link: "/creatediscountcode",
            active: window.location.pathname === "/creatediscountcode",
        },
        {
            id: "2",
            title: " کد تخفیف شخصی",
            link: "/createprivatediscountcode",
            active: window.location.pathname === "/createprivatediscountcode",
        },
        {
            id: "5",
            title: "لیست کد تخفیف شخصی",
            link: "/privatediscountcodelist",
            active: window.location.pathname === "/privatediscountcodelist",
        },
        {
            id: "3",
            title: "ایجاد کد تخفیف عمومی",
            link: "/createpublicdiscountcode",
            active: window.location.pathname === "/createpublicdiscountcode",
        },
        {
            id: "4",
            title: "لیست کد تخفیف عمومی",
            link: "/publicdiscountcodelist",
            active: window.location.pathname === "/publicdiscountcodelist",
        },

    ];
    
    const openHandlerAll=()=>{
        if(openAll){
          setOpenAll(false)
        }
        else{
          setOpenAll(true)
        }
    }

    const openHandler=()=>{
        if(openOnClick){
            setOpenOnClick(false)
        }
        else{
            setOpenOnClick(true)
        }
    }

    const openAcaredionHandler=()=>{
        if(openOnClickList){
          setOpenOnClickList(false)
        }
        else{
          setOpenOnClickList(true)
        }
    }

    let addDiscount = false;
    createDiscount.forEach((element) => {
        if (element.active) {
            addDiscount = true;
        }
    });

    let DiscountList = false;
    Discounts.forEach((element) => {
        if (element.active) {
            DiscountList = true;
        }
    });

    addDiscountCode.forEach((element) => {
        if (element.active) {
            DiscountList = true;
        }
    });

    return (
        <div className={Style.component}>
            <div className={Style.accardionChild}>
                <div
                className={Style.accardionTitle}
                onClick={openHandlerAll}
                >
                    <ChevronLeft />
                    <div className={Style.right}>
                        <p className={Style.accardionText}>مدیریت تخفیف</p>
                        <ChatLeftDotsFill />
                    </div>
                </div>
                {/* <div className={addDiscount||openAll?Style.inneraccardionContent :Style.hidden }>
                <AccardionItem accardonItem={addDiscountCode}/>
                </div> */}

                <div className={DiscountList||addDiscount||openAll  ? Style.holder:Style.hidden}>
                    {/* <div className={Style.accardionContent}>
                        <div 
                        onClick={openHandler}
                        className={addDiscount||openOnClick?Style.background :Style.innerAccardionTitle}
                        >
                            <ChevronLeft />
                            <div className={Style.right}>
                                <p className={Style.accardionText}>ایجاد تخفیف</p>
                            </div>
                        </div>
                        <div className={addDiscount||openOnClick?Style.inneraccardionContent :Style.hidden }>
                            <AccardionItem accardonItem={createDiscount&&createDiscount}/>
                        </div>
                    </div> */}

                    {/* <div className={Style.accardionContent}>
                        <div 
                        className={DiscountList||openOnClickList?Style.background :Style.innerAccardionTitle}
                        onClick={openAcaredionHandler}
                        >
                            <ChevronLeft />
                            <div className={Style.right}>
                                <p className={Style.accardionText}>لیست تخفیف های اعمال شده </p>
                            </div>
                        </div>
                        <div className={DiscountList||openOnClickList?Style.inneraccardionContent :Style.hidden }>
                            <AccardionItem accardonItem={Discounts&&Discounts}/>
                        </div>
                    </div> */}

                    <div className={addDiscountCode||openAll?Style.inneraccardionContent:Style.hidden}>
                        <AccardionItem accardonItem={addDiscountCode&&addDiscountCode}/>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Accardion6